<template>
  <el-dialog
    title="选择产品"
    :visible="visible"
    @close="onClose"
    width="60%"
    top="5vh"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="top">
      <div>
        <el-input
          v-model.trim="form['Name:like']"
          placeholder="站点名称"
          @keydown.enter.native="onSubmitQuery"
          style="width: 250px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table
      ref="tb"
      :data="itemList"
      v-loading="loading"
      :row-key="getRowKey"
      @selection-change="onSelectChanged"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column prop="Name" label="站点名称" />
      <el-table-column label="授权码" width="250"
        ><template slot-scope="scope">
          <el-tag v-if="scope.row.Code">
            {{ scope.row.Code.Name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="所属区域" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.Province">{{ scope.row.Province.Name }}</span>
          <span v-if="scope.row.City">/{{ scope.row.City.Name }}</span>
          <span v-if="scope.row.County">/{{ scope.row.County.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="StationType.Name"
        label="站点类型"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型"
        width="80"
      ></el-table-column>
      <el-table-column width="80" align="center" label="在线状态">
        <template slot-scope="scope">
          <el-tooltip content="Top center" placement="top" effect="light">
            <div slot="content" v-if="scope.row.HeartBeat === true">在线</div>
            <div slot="content" v-else>离线</div>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #92c655; cursor: pointer"
              v-if="scope.row.HeartBeat === true"
            ></i>
            <i
              class="fa fa-wifi fa-lg"
              style="color: #f0615e; cursor: pointer"
              v-else
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="onSubmit">
        <i class="far fa-save"></i> 确 定
      </el-button>
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      itemList: [],
      form: {
        "Name:like": "",
      },
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      options: [],
      loading: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("station", {
          params: {
            where: this.form,
            ...this.pager,
            with: [
              "Code",
              "BusinessType",
              "StationType",
              "Province",
              "City",
              "County",
            ],
            order: ["-id"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
          if (this.pager.page > response.data.last) {
            this.pager.page = response.data.last;
            this.getItemList();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onSelectChanged(options) {
      this.options = options;
    },
    // 选择产品
    onSubmit() {
      this.$emit("update", this.options);
      this.onClose();
    },
    // 关闭
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.tb.clearSelection();
    },
    getRowKey(row) {
      return row.ID;
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 8px 10px 5px 30px;
  margin: -30px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>
